// extracted by mini-css-extract-plugin
export var footer = "Layout-module--footer--218b8";
export var header = "Layout-module--header--fc210";
export var pageContent = "Layout-module--pageContent--74fbe";